// extracted by mini-css-extract-plugin
module.exports = {"BooksTermsOfUse":"BooksTermsOfUse_BooksTermsOfUse__Th1_T","BooksTermsOfUse__Text":"BooksTermsOfUse_BooksTermsOfUse__Text__N0Ms6"};